import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Form } from 'formik';
import { useSelector } from 'react-redux';
import { FormCurrencyInputField } from '../../common/components/formFields';

function SettingsForm() {
  const validationErrors = useSelector((state) => state.settings.get('validationErrors'));

  const {
    monthlySubscriptionInPence,
    launchInPence,
    saleForLessThan1000InPence,
    saleBetween1001And5000InPence,
    saleBetween5001And10000InPence,
    saleBetween10001And15000InPence,
    saleForMoreThan15000InPence,
    purchaseForLessThan1000InPence,
    purchaseBetween1001And5000InPence,
    purchaseBetween5001And10000InPence,
    purchaseBetween10001And15000InPence,
    purchaseForMoreThan15000InPence,
  } = validationErrors;

  return (
    <Form noValidate>
      <Row>
        <Col md="4">
          <FormCurrencyInputField
            name="monthlySubscriptionInPence"
            label="Monthly Subscription"
          />
          {monthlySubscriptionInPence && (
            <label className="error-label">{monthlySubscriptionInPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField name="launchInPence" label="Launch Fee" />
          {launchInPence && <label className="error-label">{launchInPence}</label>}
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormCurrencyInputField name="saleForLessThan1000InPence" label="Sale £0 - £1,000" />
          {saleForLessThan1000InPence && (
            <label className="error-label">{saleForLessThan1000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="saleBetween1001And5000InPence"
            label="Sale £1,001 - £5,000"
          />
          {saleBetween1001And5000InPence && (
            <label className="error-label">{saleBetween1001And5000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="saleBetween5001And10000InPence"
            label="Sale £5,001 - £10,000"
          />
          {saleBetween5001And10000InPence && (
            <label className="error-label">{saleBetween5001And10000InPence}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormCurrencyInputField
            name="saleBetween10001And15000InPence"
            label="Sale £10,001 - £15,000"
          />
          {saleBetween10001And15000InPence && (
            <label className="error-label">{saleBetween10001And15000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="saleForMoreThan15000InPence"
            label="Sale for more than £15,000"
          />
          {saleForMoreThan15000InPence && (
            <label className="error-label">{saleForMoreThan15000InPence}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormCurrencyInputField
            name="purchaseForLessThan1000InPence"
            label="Purchase £0 - £1,000"
          />
          {purchaseForLessThan1000InPence && (
            <label className="error-label">{purchaseForLessThan1000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="purchaseBetween1001And5000InPence"
            label="Purchase £1,001 - £5,000"
          />
          {purchaseBetween1001And5000InPence && (
            <label className="error-label">{purchaseBetween1001And5000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="purchaseBetween5001And10000InPence"
            label="Purchase £5,001 - £10,000"
          />
          {purchaseBetween5001And10000InPence && (
            <label className="error-label">{purchaseBetween5001And10000InPence}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormCurrencyInputField
            name="purchaseBetween10001And15000InPence"
            label="Purchase £10,001 - £15,000"
          />
          {purchaseBetween10001And15000InPence && (
            <label className="error-label">{purchaseBetween10001And15000InPence}</label>
          )}
        </Col>
        <Col md="4">
          <FormCurrencyInputField
            name="purchaseForMoreThan15000InPence"
            label="Purchase for more than £15,000"
          />
          {purchaseForMoreThan15000InPence && (
            <label className="error-label">{purchaseForMoreThan15000InPence}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Button className="mt-4 float-end rounded-pill btn-primary" type="submit">
            Save
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default SettingsForm;
